<template>
  <div id="app">
    <div id="nav" v-if="$route.name !== 'login'">
      <router-link to="/">Site CRA-RS</router-link>
      <router-link v-if="!isEngUser" to="/paginas">Criar Páginas</router-link>
      <router-link to="/logout" class="logout"><font-awesome-icon icon="sign-out-alt"/> Sair</router-link>
    </div>
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'appbase',
  components: {},
  computed: {
    isEngUser() {
      if (typeof window !== 'undefined' && window.localStorage) {
        return localStorage.getItem('eng-user') !== null && localStorage.getItem('eng-user') == 'true';
      }
      return false;
    }
  },
  methods: {
  }
}
</script>

<style lang="scss">
@import "assets/scss/global";

#app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    display: grid;
    grid-template-columns: 200px 1fr;
  height: 100vh;
  overflow: hidden;
}

#nav {
  padding: 10px 10px;
  background-color: $dark;
  min-height: 100vh;
  box-shadow: 0 14px 28px rgba(0,0,0,0.25), 0 10px 10px rgba(0,0,0,0.22);
  position: relative;

  a {
    display: block;
    font-weight: bold;
    color: #fff;
    text-decoration: none;
    font-size: 1.2rem;
    margin-bottom: 10px;
    padding: 10px;
    background-color: #343434;
    border-radius: 10px;

    &.router-link-exact-active {
      background-color: $alt;
      color: #fff;
    }

    &.logout {
      background-color: $danger;
      position: absolute;
      bottom: 0;
      left: 10px;
    }
  }
}
</style>
